module.exports = __webpack_public_path__ + "static/media/codeingame.83f176ca.svg";